function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var _require = require('./database'),
  SYNTHETIC_INBOUND_TX_HASH = _require.SYNTHETIC_INBOUND_TX_HASH;
var TEST_SENDER = 'admin-test';
var TEST_HASH = SYNTHETIC_INBOUND_TX_HASH;
function testTransferId(id) {
  return "".concat(TEST_HASH, ":").concat(id);
}
function transferId(value) {
  var id = Number(value);
  if (!Number.isInteger(id) || id <= 0) {
    return 0;
  }
  return id;
}
var TransferTesting = /*#__PURE__*/function () {
  function TransferTesting(app, mod) {
    _classCallCheck(this, TransferTesting);
    this.app = app;
    this.mod = mod;
  }
  return _createClass(TransferTesting, [{
    key: "listOutstandingTransfers",
    value: function () {
      var _listOutstandingTransfers = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this = this;
        var _ref,
          _ref$search,
          search,
          _ref$page,
          page,
          _ref$purpose,
          purpose,
          listed,
          _args = arguments;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _ref = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, _ref$search = _ref.search, search = _ref$search === void 0 ? '' : _ref$search, _ref$page = _ref.page, page = _ref$page === void 0 ? 1 : _ref$page, _ref$purpose = _ref.purpose, purpose = _ref$purpose === void 0 ? '' : _ref$purpose;
              _context.n = 1;
              return this.mod.database.listAdminTransfers({
                search: search,
                page: page,
                purpose: purpose
              });
            case 1:
              listed = _context.v;
              return _context.a(2, {
                transfers: (listed.rows || []).map(function (row) {
                  return _this.snapshot(row);
                }),
                total: listed.total,
                page: listed.page,
                page_size: listed.page_size
              });
          }
        }, _callee, this);
      }));
      function listOutstandingTransfers() {
        return _listOutstandingTransfers.apply(this, arguments);
      }
      return listOutstandingTransfers;
    }()
  }, {
    key: "excludeTransfer",
    value: function () {
      var _excludeTransfer = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(id) {
        var transferIdValue, rows, transfer, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              transferIdValue = transferId(id);
              if (!transferIdValue) {
                _context2.n = 2;
                break;
              }
              _context2.n = 1;
              return this.mod.database.getTransfers({
                id: transferIdValue
              });
            case 1:
              _t = _context2.v;
              _context2.n = 3;
              break;
            case 2:
              _t = [];
            case 3:
              rows = _t;
              transfer = rows === null || rows === void 0 ? void 0 : rows[0];
              if (transfer) {
                _context2.n = 4;
                break;
              }
              throw new Error('No transfer matches that id.');
            case 4:
              _context2.n = 5;
              return this.mod.database.updateTransfer(transfer.id, {
                excluded: 1
              });
            case 5:
              return _context2.a(2, this.listOutstandingTransfers());
          }
        }, _callee2, this);
      }));
      function excludeTransfer(_x) {
        return _excludeTransfer.apply(this, arguments);
      }
      return excludeTransfer;
    }()
  }, {
    key: "advanceTransfer",
    value: function () {
      var _advanceTransfer = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(id, action) {
        var transferIdValue, rows, found, transfer, _t2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              transferIdValue = transferId(id);
              if (!transferIdValue) {
                _context3.n = 2;
                break;
              }
              _context3.n = 1;
              return this.mod.database.getTransfers({
                id: transferIdValue
              });
            case 1:
              _t2 = _context3.v;
              _context3.n = 3;
              break;
            case 2:
              _t2 = [];
            case 3:
              rows = _t2;
              found = rows === null || rows === void 0 ? void 0 : rows[0];
              if (!((found === null || found === void 0 ? void 0 : found.purpose) === 'store-purchase')) {
                _context3.n = 8;
                break;
              }
              if (!(Number(found.excluded) === 1)) {
                _context3.n = 4;
                break;
              }
              throw new Error('That transfer is excluded from processing.');
            case 4:
              if (!(action !== 'detect-inbound')) {
                _context3.n = 5;
                break;
              }
              throw new Error("Unknown payment test action: ".concat(action || ''));
            case 5:
              if (!(found.status !== 'inbound_awaiting')) {
                _context3.n = 6;
                break;
              }
              throw new Error("Transfer ".concat(found.id, " cannot be marked detected from status ").concat(found.status, "."));
            case 6:
              _context3.n = 7;
              return this.mod.transfers.recordStorePurchaseInboundPayment(found, {
                hash: TEST_HASH,
                id: testTransferId(found.id),
                sender: TEST_SENDER,
                amount: found.inbound_amount
              });
            case 7:
              return _context3.a(2, this.listOutstandingTransfers());
            case 8:
              _context3.n = 9;
              return this.returnBuySaitoTransfer(id);
            case 9:
              transfer = _context3.v;
              if (!(Number(transfer.excluded) === 1)) {
                _context3.n = 10;
                break;
              }
              throw new Error('That transfer is excluded from processing.');
            case 10:
              if (!(action === 'detect-inbound')) {
                _context3.n = 12;
                break;
              }
              _context3.n = 11;
              return this.detectInbound(transfer);
            case 11:
              _context3.n = 15;
              break;
            case 12:
              if (!(action === 'confirm-inbound')) {
                _context3.n = 14;
                break;
              }
              _context3.n = 13;
              return this.confirmInbound(transfer);
            case 13:
              _context3.n = 15;
              break;
            case 14:
              throw new Error("Unknown payment test action: ".concat(action || ''));
            case 15:
              return _context3.a(2, this.listOutstandingTransfers());
          }
        }, _callee3, this);
      }));
      function advanceTransfer(_x2, _x3) {
        return _advanceTransfer.apply(this, arguments);
      }
      return advanceTransfer;
    }()
  }, {
    key: "returnBuySaitoTransfer",
    value: function () {
      var _returnBuySaitoTransfer = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(id) {
        var transferIdValue, rows, transfer, _t3;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              transferIdValue = transferId(id);
              if (!transferIdValue) {
                _context4.n = 2;
                break;
              }
              _context4.n = 1;
              return this.mod.database.getTransfers({
                id: transferIdValue
              });
            case 1:
              _t3 = _context4.v;
              _context4.n = 3;
              break;
            case 2:
              _t3 = [];
            case 3:
              rows = _t3;
              transfer = rows === null || rows === void 0 ? void 0 : rows[0];
              if (!(!transfer || transfer.purpose !== 'buysaito')) {
                _context4.n = 4;
                break;
              }
              throw new Error('No outstanding BuySaito transfer matches that id.');
            case 4:
              return _context4.a(2, transfer);
          }
        }, _callee4, this);
      }));
      function returnBuySaitoTransfer(_x4) {
        return _returnBuySaitoTransfer.apply(this, arguments);
      }
      return returnBuySaitoTransfer;
    }()
  }, {
    key: "detectInbound",
    value: function () {
      var _detectInbound = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(transfer) {
        var required, updated;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              if (!(transfer.status !== 'inbound_awaiting')) {
                _context5.n = 1;
                break;
              }
              throw new Error("Transfer ".concat(transfer.id, " cannot be marked detected from status ").concat(transfer.status, "."));
            case 1:
              required = Math.max(Number(transfer.inbound_confirmations_required) || 0, 1);
              _context5.n = 2;
              return this.mod.database.updateTransfer(transfer.id, {
                status: 'inbound_broadcast',
                inbound_tx_hash: TEST_HASH,
                inbound_tx_id: testTransferId(transfer.id),
                inbound_sender: TEST_SENDER,
                inbound_confirmations: 0,
                inbound_confirmations_required: required,
                inbound_received_at: Date.now()
              });
            case 2:
              _context5.n = 3;
              return this.returnBuySaitoTransfer(transfer.id);
            case 3:
              updated = _context5.v;
              this.notifyPaymentDetected(updated, 'pending');
            case 4:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function detectInbound(_x5) {
        return _detectInbound.apply(this, arguments);
      }
      return detectInbound;
    }()
  }, {
    key: "confirmInbound",
    value: function () {
      var _confirmInbound = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(transfer) {
        var required, updated;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              if (!(transfer.status !== 'inbound_broadcast' || transfer.inbound_tx_id !== testTransferId(transfer.id))) {
                _context6.n = 1;
                break;
              }
              throw new Error("Transfer ".concat(transfer.id, " cannot be marked confirmed from its current evidence."));
            case 1:
              required = Math.max(Number(transfer.inbound_confirmations_required) || 0, 1);
              _context6.n = 2;
              return this.mod.database.updateTransfer(transfer.id, {
                status: 'inbound_confirmed',
                inbound_confirmations: required,
                inbound_confirmations_required: required
              });
            case 2:
              _context6.n = 3;
              return this.returnBuySaitoTransfer(transfer.id);
            case 3:
              updated = _context6.v;
              this.notifyPaymentDetected(updated, 'confirmed');
            case 4:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function confirmInbound(_x6) {
        return _confirmInbound.apply(this, arguments);
      }
      return confirmInbound;
    }()
  }, {
    key: "notifyPaymentDetected",
    value: function notifyPaymentDetected(transfer, status) {
      var _this$mod$notifyBrows, _this$mod;
      var detected = {
        id: transfer.id,
        address: transfer.inbound_address,
        ticker: transfer.inbound_ticker,
        status: status,
        initiator_pubkey: transfer.requester_publickey
      };
      (_this$mod$notifyBrows = (_this$mod = this.mod).notifyBrowser) === null || _this$mod$notifyBrows === void 0 || _this$mod$notifyBrows.call(_this$mod, 'buysaito payment detected', detected, transfer.requester_publickey);
      this.app.connection.emit('saito-purchase-payment-detected', detected);
    }
  }, {
    key: "snapshot",
    value: function snapshot(transfer) {
      return {
        id: transfer.id,
        requester_publickey: transfer.requester_publickey || '',
        recipient_publickey: transfer.recipient_publickey || '',
        inbound_ticker: transfer.inbound_ticker || '',
        inbound_amount: transfer.inbound_amount || '',
        outbound_ticker: transfer.outbound_ticker || 'SAITO',
        outbound_amount: transfer.outbound_amount || '',
        status: transfer.status,
        last_error: transfer.last_error || '',
        purpose: transfer.purpose || '',
        mode: transfer.mode || '',
        inbound_address: transfer.inbound_address || '',
        inbound_tx_hash: transfer.inbound_tx_hash || '',
        inbound_sender: transfer.inbound_sender || '',
        outbound_address: transfer.outbound_address || '',
        outbound_sender: transfer.outbound_sender || '',
        outbound_tx_sig: transfer.outbound_tx_sig || '',
        publickey: transfer.publickey || '',
        action: this.nextAction(transfer)
      };
    }
  }, {
    key: "nextAction",
    value: function nextAction(transfer) {
      if (transfer.purpose === 'store-purchase') {
        if (transfer.status === 'inbound_awaiting') {
          return {
            action: 'detect-inbound',
            label: 'Mark inbound payment detected'
          };
        }
        return null;
      }
      if (transfer.purpose && transfer.purpose !== 'buysaito') {
        return null;
      }
      if (transfer.status === 'inbound_awaiting') {
        return {
          action: 'detect-inbound',
          label: 'Mark inbound payment detected'
        };
      }
      if (transfer.status === 'inbound_broadcast' && transfer.inbound_tx_id === testTransferId(transfer.id)) {
        return {
          action: 'confirm-inbound',
          label: 'Mark inbound payment confirmed'
        };
      }
      return null;
    }
  }]);
}();
module.exports = TransferTesting;